import { useFormContext } from '../../../hooks/useForm';
import { UpdateContactInfoAction, UpdateContactInfoActionType } from './actions';
import { UpdateContactInfoState } from './state';
import { Error } from './validate';

export default useFormContext<UpdateContactInfoState, UpdateContactInfoAction, Error, UpdateContactInfoActionType>;
